import { PayloadAction } from '@reduxjs/toolkit'
import { WritableDraft } from 'immer/dist/internal'
import { getSelectedAdGroup } from '../utils'
import { ICampaign, IAdGroup } from '../../../models'

const removeAdGroupProducts = (
  state: WritableDraft<ICampaign>,
  action: PayloadAction<{
    productIds: Array<number>
    adGroupId: number
  }>
) => {
  const selectedAdGroup =
    getSelectedAdGroup(state, action.payload.adGroupId) || ({} as IAdGroup)

  if (selectedAdGroup.productList === undefined) {
    selectedAdGroup.productList = []
  } else {
    selectedAdGroup.productList = selectedAdGroup.productList.filter(
      (sp) => !action.payload.productIds.includes(sp.id)
    )
  }
}

export default removeAdGroupProducts
